import { ApexOptions } from "apexcharts";
import Chart from "react-apexcharts";
import { BRLFormat } from "shared/helpers/BRLFormat";

interface RangeColumnChartProps {
  series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  height: number;
  width: number;
  colors: any;
  fontSize?: string;
}

const RangeColumnChart: React.FC<RangeColumnChartProps> = (props) => {
  const { series, height, width, colors, fontSize } = props;
  const options: ApexOptions = {
    chart: {
      type: "rangeBar",
      toolbar: {
        show: false,
      },
    },
    colors: colors,
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
      },
    },
    yaxis: {
      labels: {
        show: false,
        formatter: (val: number) => BRLFormat(val),
        style: { fontSize: fontSize },
      },
    },
    xaxis: {
      labels: {
        style: { fontSize: fontSize },
      },
    },
    dataLabels: {
      enabled: true,
      style: { colors: ["#000"], fontSize: fontSize, fontWeight: 400 },
      formatter: function (_, opts: any) {
        const y =
          opts?.w?.config?.series[opts.seriesIndex]?.data[opts?.dataPointIndex]
            ?.y;
        return BRLFormat(y[1] - y[0]);
      },
    },
    tooltip: {
      enabled: false,
    },
  };

  return (
    <Chart
      series={series}
      options={options}
      type="rangeBar"
      height={height}
      width={width}
    />
  );
};

export default RangeColumnChart;
